import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IconService } from '../../_core/services/icon.service';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { Shareholder } from './shareholder';
import { SharedModule } from '../../_shared/shared.module';
import { ShareholderDialogComponent } from '../shareholder-dialog/shareholder-dialog.component';
import { FullScreenDialogConfig } from '../../_config/full-screen-dialog-config';
import { of, switchMap } from 'rxjs';
import { DialogService } from '../../_core/services/dialog.service';
import { PersonaGiuridica } from '../models/persona-giuridica';

@Component({
  selector: 'app-shareholders-table',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './shareholders-table.component.html',
  styleUrls: ['./shareholders-table.component.scss'],
})
export class ShareholdersTableComponent {
  @Input() personaGiuridica?: PersonaGiuridica;
  @Output() onEditShareholders = new EventEmitter<Shareholder[]>();

  displayedColumns: (keyof Shareholder | 'actions')[] = [
    'type',
    'country',
    'share',
    'actions',
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    public praticaProgressService: PraticaProgressService,
    private iconService: IconService,
    private dialogService: DialogService
  ) {
    this.iconService.getIcons(['delete', 'edit']);
  }

  openShareholderDialog(shareholder?: Shareholder, index?: number) {
    let dialogRef = this.dialogService.open<
      ShareholderDialogComponent,
      ShareholderDialogComponent['data']
    >(ShareholderDialogComponent, {
      ...FullScreenDialogConfig,
      data: {
        shareholder,
        personaGiuridica: this.personaGiuridica,
      },
    });

    dialogRef
      .afterClosed()
      .pipe()
      .subscribe((formData) => {
        if (formData) {
          this.saveShareholder(formData, shareholder, index);
        }
      });
  }

  deleteShareholder(element: Shareholder) {
    let updatedShareholders = this.personaGiuridica?.extension?.[
      'shareholders'
    ]?.filter((s) => s !== element);
    this.onEditShareholders.emit(updatedShareholders);
  }

  saveShareholder(
    formData: Partial<Shareholder>,
    shareholder?: Shareholder,
    index?: number
  ) {
    let updatedShareholders = [
      ...(this.personaGiuridica?.extension?.['shareholders'] || []),
    ];
    if (!shareholder) {
      updatedShareholders.push(formData as Shareholder);
    } else {
      shareholder = { ...shareholder, ...formData };
      updatedShareholders[index as number] = shareholder;
    }
    this.onEditShareholders.emit(updatedShareholders);
  }
}
